import axios from "axios";
import { openai } from "../../config";
import { appToken, serverNodeApiUrl as serverApiUrl, serverNodeApiUrl } from "../../index";
const token =
  "Bearer " + "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdGF0dXMiOiJVTkJMT0NLRUQiLCJpZCI6ODkyMjA2ODc5MCwibW9iaWxlIjoiJDJiJDEwJG43TEZEeTJSaXJEa1lYelNuSWlIcU90WlUzcC9SaU9jZUNmUWZLVzFQYzV6WWZabzRNZElpIiwidXNlclR5cGUiOiJBRE1JTiIsInVwZGF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImNyZWF0ZWRBdCI6IjIwMjUtMDItMjZUMDk6MDg6MDIuNDkxWiIsImlhdCI6MTc0MDU2MDg4MiwiZXhwIjoxNzQzMTg4ODgyLCJpc3MiOiJEVUJ1ZGR5In0.QzQhSkCs2juC-06HGHwBbXIDVTPLjv78715QMcXIROM";
const VERTEX_API =
  "https://discoveryengine.googleapis.com/v1alpha/projects/540057655159/locations/global/collections/default_collection/dataStores/jsonl-temp_1715705290455/servingConfigs/default_search:search";

export const fetch_institute_testSeries = (insId, page, limit, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  fetch(
    serverApiUrl +
    "testseries/admin/testSeries/getAllInstituteTestSeries/" +
    insId +
    "/" +
    page +
    "/" +
    limit,
    {
      method: "GET",
      headers,
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const fetch_testSeries_by_subCategory = (
  subcategoryId,
  page,
  limit,
  callback
) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  // headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  headers.append("Authorization", token);

  fetch(
    serverNodeApiUrl +
    "testseries/admin/testSeries/getTestSeriesBySubCategoryId/" +
    subcategoryId +
    "/" +
    page +
    "/" +
    limit,
    // serverApiUrl +
    //   "testSeries/getTestSeriesBySubCategoryId/" +
    //   subcategoryId +
    //   "/" +
    //   page +
    //   "/" +
    //   limit,
    {
      method: "GET",
      headers,
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const getTestSeriesById = (testSeriesId, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  // headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");
  headers.append("Authorization", token);

  headers.append("GET", "POST", "OPTIONS");
  fetch(
    serverNodeApiUrl + "testseries/admin/testseries/testseries/" + testSeriesId,
    // serverApiUrl + "testSeries/testSeries/" + testSeriesId,
    {
      method: "GET",
      headers,
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const fetch_institute_testSeries_section = (seriesId, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  // headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  headers.append("Authorization", token);
  fetch(
    // serverApiUrl + "testSeries/testSeriesSections/" + seriesId,
    serverNodeApiUrl + "testseries/admin/testseries/testseriesSections/" + seriesId,
    {
      method: "GET",
      headers,
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const fetch_institute_testSeries_sectionQuestion = (
  sectionId,
  page,
  limit,
  callback
) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  // headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");
  headers.append("Authorization", token);
  headers.append("GET", "POST", "OPTIONS");
  fetch(
    serverNodeApiUrl +
    "testseries/admin/section/testSeriesSectionQuestions/" +
    // serverApiUrl +
    //   "testSeries/testSeriesSectionQuestions/" +
    sectionId +
    "/" +
    page +
    "/" +
    limit,
    {
      method: "GET",
      headers,
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const add_institute_testSeries = (data, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", token);
  fetch(
    // serverApiUrl + "testSeries/",
    serverNodeApiUrl + "testseries/admin/testseries/testSeries/",

    {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const addQuestionBulk = (data, callback) => {
  console.log(data);
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  // headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  headers.append("Authorization", token);

  fetch(
    //serverApiUrl + "testSeries/questionBulk",
    serverNodeApiUrl + "testseries/admin/testSeries/questionBulk",

    {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const addSection = (data, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  // headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");
  headers.append("GET", "POST", "OPTIONS");
  headers.append("Authorization", token);

  fetch(
    // serverApiUrl + "testSeries/section",
    serverNodeApiUrl + "testseries/admin/section/section",

    {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const addSectionBulk = (data, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");

  fetch(serverApiUrl + "testseries/admin/testSeries/sectionBulk", {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  })
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const editTestSeriesSection = (data, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  headers.append("Authorization", token);
  fetch(serverNodeApiUrl + "testseries/admin/section/section/" + data?.id, {
    method: "PUT",
    headers,
    body: JSON.stringify(data),
  })
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const deleteTestSeries = (id, index, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  fetch(serverApiUrl + "testSeries/" + id, {
    method: "DELETE",
    headers,
  })
    .then((response) => callback(response, index))
    .catch((error) => {
      console.log(error);
    });
};
export const deleteSection = (id, index, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  fetch(serverApiUrl + "testseries/admin/testSeries/testSeriesSection/" + id, {
    method: "DELETE",
    headers,
  })
    .then((response) => callback(response, index))
    .catch((error) => {
      console.log(error);
    });
};

export const changeCompulsion = async (optional, id) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  const response = await fetch(
    serverApiUrl + "testseries/admin/testSeries/updateIsOptionalSection/" + optional + "/" + id,
    {
      method: "PUT",
      headers,
    }
  );
  if (response.status == 200) {
    return { status: true, message: "updated successfully." };
  } else {
    throw new Error("Something went wrong, while updating.");
  }
};

export const deleteTestSeriesQuestion = (id, index, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  fetch(serverApiUrl + "testseries/admin/testSeriesQuestion/deleteQuestion/" + id, {
    method: "DELETE",
    headers,
  })
    .then((response) => callback(response, index))
    .catch((error) => {
      console.log(error);
    });
};
export const updateTestSeriesQuestionStatus = async (
  id,
  isPublished,
  sectionId
) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", token);
    const response = await fetch(
      serverNodeApiUrl +
      "testseries/admin/testSeries/updateTestSeriesQuestionPublishedStatus/" +
      // serverApiUrl +
      //   "testSeries/updateTestSeriesQuestionPublishedStatus/" +
      isPublished +
      "/" +
      sectionId +
      "/" +
      id,
      {
        method: "PUT",
        headers,
      }
    );
    if (response.status == 200) {
      return { status: true, message: "deleted successfully." };
    } else {
      throw new Error("Something went wrong, while deleting.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const editInstituteTestSeriesStatus = (id, status, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  // headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");
  headers.append("Authorization", token);

  headers.append("GET", "POST", "OPTIONS");
  fetch(
    // serverApiUrl + "testSeries/testSeriesStatus/" + id + "/" + status,
    serverNodeApiUrl + "testseries/admin/testseries/testSeriesStatus/" + id + "/" + status,
    {
      method: "PUT",
      headers,
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const editTestSeriesQuestion = (data, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  fetch(serverApiUrl + "testseries/admin/testSeries/questionLanguageVarient", {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  })
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const updateAllQuestionsMarks = (data, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  fetch(
    serverApiUrl +
    "testseries/admin/testSeries/updateTestSeriesQuestionMarksBySection/" +
    data.posMarks +
    "/" +
    data.negMarks +
    "/" +
    data.negMarksUnattempted +
    "/" +
    data.testSeriesSectionId,
    {
      method: "PUT",
      headers,
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};
export const updateSingleQuestionMarks = (data, callback) => {
  let headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("Access-Control-Allow-Origin", serverApiUrl);
  headers.append("Access-Control-Allow-Credentials", "true");

  headers.append("GET", "POST", "OPTIONS");
  fetch(
    serverApiUrl +
    "testseries/admin/testSeries/updateQuestionMarksById/" +
    data.posMarks +
    "/" +
    data.negMarks +
    "/" +
    data.negMarksUnattempted +
    "/" +
    data.questionId,
    {
      method: "PUT",
      headers,
    }
  )
    .then((response) => callback(response))
    .catch((error) => {
      console.log(error);
    });
};

export const editTestSeries = async (data) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverNodeApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(serverNodeApiUrl + "testseries/admin/testSeries/editTestSeries", {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    if (response.status === 200) {
      return { status: true, message: "updated successfully." };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const editQuestionCorrectPromptAndLanguageVarient = async (
  data,
  callback
) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl +
      "testseries/admin/testseries/editQuestionCorrectPromptAndLanguageVarient",

      // serverApiUrl + "testSeries/editQuestionCorrectPromptAndLanguageVarient",
      {
        method: "PUT",
        headers,
        body: JSON.stringify(data),
      }
    );
    if (response.status == 200) {
      const res = await response.json();
      console.log(res);

      callback({
        status: true,
        data: res.data,
        message: "updated successfully.",
      });
      return {
        status: true,
        data: res.data,
        message: "updated successfully.",
      };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const deleteQuestionLanguageOption = async (id) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    const response = await fetch(
      serverApiUrl + "testseries/admin/testSeries/testSeriesQuestionOption/" + id,
      {
        method: "DELETE",
        headers,
      }
    );
    if (response.status == 200) {
      return { status: true, message: "deleted successfully." };
    } else {
      throw new Error("Something went wrong, while deleting.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const changeTextUsingOpenAi = async (text, prompt) => {
  const response = await openai.createChatCompletion({
    model: "gpt-3.5-turbo",
    messages: [{ role: "user", content: prompt + text }],
    temperature: 0.4,
    max_tokens: 2048,
    top_p: 1,
    frequency_penalty: 0,
    presence_penalty: 0,
  });

  return { status: true, data: response.data.choices[0].message };
};

export const updateConvertedQuestionValue = async (data) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", token);
    const response = await fetch(
      serverNodeApiUrl + "testseries/admin/testSeriesQuestionLanguageVariant/updateVariant",
      {
        method: "PATCH",
        headers,
        body: JSON.stringify(data),
      }
    );

    if (response.status === 200) {
      return { status: true, message: "updated successfully." };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
export const updateConvertedSolutionValue = async (data) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", token);
    const response = await fetch(
      serverNodeApiUrl + "testseries/admin/testSeriesQuestionLanguageVariant/updateVariant",
      {
        method: "PATCH",
        headers,
        body: JSON.stringify(data),
      }
    );

    if (response.status === 200) {
      return { status: true, message: "updated successfully." };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const updateQuestionOptionConvertedValue = async (data) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    const response = await fetch(
      serverApiUrl + "testseries/admin/testSeries/updateQuestionOptionConvertedValue",
      {
        method: "PUT",
        headers,
        body: JSON.stringify(data),
      }
    );

    if (response.status == 200) {
      return { status: true, message: "updated successfully." };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const countUsersByTestSeriesId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admin/testSeriesResponse/" + id + "/users-attempted"
    );
    const count = await response.json();
    return { status: true, data: count };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const countUsersSubmittedByTestSeriesId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admin/testSeriesResponse/" + id + "/users-submitted"
    );
    const count = await response.json();
    return { status: true, data: count };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getAverageScoreByTestSeriesId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admin/testSeriesResponse/" + id + "/average-score"
    );
    const averageScore = await response.json();
    return { status: true, data: averageScore };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getMinScoreByTestSeriesId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admin/testSeriesResponse/" + id + "/min-score"
    );
    const minScore = await response.json();
    return { status: true, data: minScore };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getSubmittedCountByTestSeriesId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admintestSeriesResponse/" + id + "/submitted-count"
    );
    const submittedCount = await response.json();
    return { status: true, data: submittedCount };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getNotSubmittedCountByTestSeriesId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admintestSeriesResponse/" + id + "/not-submitted-count"
    );
    const notSubmittedCount = await response.json();
    return { status: true, data: notSubmittedCount };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getPaidTestSeriesUserCount = async () => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admintestSeriesResponse/" + "paid-user-count"
    );
    const count = await response.json();
    return { status: true, data: count };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getPurchasedCountByTestSeriesId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admintestSeriesResponse/" + id + "/purchased-count"
    );
    const count = await response.json();
    return { status: true, data: count };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const getRevenueByTestSeriesId = async (id) => {
  try {
    const response = await fetch(
      serverApiUrl + "testseries/admintestSeriesResponse/" + id + "/revenue"
    );
    const revenue = await response.json();
    return { status: true, data: revenue };
  } catch (error) {
    console.log(error);
    return { status: false, message: error };
  }
};

export const fetch_all_interns = async () => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      serverApiUrl + "testseries/adminintern/",

      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();
      return {
        status: true,
        data: data,
        message: "Interns fetched successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const assign_intern = async (data) => {
  console.log(data);

  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");

    const response = await fetch(
      // /api/v1/testSeries/assignInternToTestSeries/{internId}/{id}
      serverApiUrl +
      "testseries/admintestSeries/assignInternToTestSeries/" +
      data.internId +
      "/" +
      data?.id,

      {
        method: "PUT",
        headers,
      }
    );
    if (response.status == 200) {
      //   const data = await response.json();
      return {
        status: true,
        // data: data,
        message: "Intern Assigned Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const update_link_intern = async (data) => {

  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl +
      "testseries/admin/testseries/updateLinkActiveForIntern/" +
      data?.status +
      "/" +
      data?.id,
      // serverApiUrl +
      //   "testSeries/updateLinkActiveForIntern/" +
      //   data?.status +
      //   "/" +
      //   data?.id,
      {
        method: "PUT",
        headers,
      }
    );
    if (response.status === 200) {
      //   const data = await response.json();
      return {
        status: true,
        // data: data,
        message: "Link Status Changed Successfully.",
      };
    } else {
      throw new Error("Something went wrong, while fetching data.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const convertImgToText = async (url) => {
  try {
    const formData = new FormData();

    formData.append("url", url.slice(1, -1));
    formData.append("filetype", "PNG");
    formData.append("isOverlayRequired", true);

    for (const pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
    let headers = new Headers();
    // headers.append("Content-Type", "application/x-www-form-urlencoded");
    // headers.append("Content-Type", "application/json");
    headers.append("apiKey", "K81267563988957");
    const response = await fetch("https://api.ocr.space/parse/image", {
      method: "POST",
      headers,
      body: formData,
    });

    if (response.status == 200) {
      const data = await response.json();
      return { status: true, response: data };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const updateOCRText = async (variantId, text) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl + "testseries/admin/testSeries/updateLanguageVariant",
      {
        method: "PUT",
        headers,
        body: JSON.stringify({ variantId, text }),
      }
    );
    if (response.status == 200) {
      return { status: true, message: "updated successfully." };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const getSimilarQuestions = async (text) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl + `testseries/admin/testseries/getSimilarQuestions?text=${text}`,
      {
        method: "GET",
        headers,
      }
    );
    if (response.status == 200) {
      const data = await response.json();

      return { status: true, data: data, message: "fetched successfully." };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};

export const addSimilarQuestions = async (questionId, similarQuestionId) => {
  try {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    // headers.append("Access-Control-Allow-Origin", serverApiUrl);
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("GET", "POST", "OPTIONS");
    headers.append("Authorization", token);

    const response = await fetch(
      serverNodeApiUrl + `testseries/admin/testseries/addSimilarQuestions`,
      {
        method: "POST",
        headers,
        body: JSON.stringify({ questionId, similarQuestionId }),
      }
    );
    if (response.status == 200) {
      const data = await response.json();

      return { status: true, data: data, message: "added successfully." };
    } else {
      throw new Error("Something went wrong, while updating.");
    }
  } catch (e) {
    console.log(e);
    return { status: false, message: e };
  }
};
